import { render } from "./edit-kpi.vue?vue&type=template&id=4b7f3566"
import script from "./edit-kpi.vue?vue&type=script&lang=js"
export * from "./edit-kpi.vue?vue&type=script&lang=js"
script.render = render

export default script